// Phase 29.5.1 · pure response-parsing helpers extracted so they can be
// covered by Jest unit tests without pulling react-router-dom into the
// module graph (CRA's jest config chokes on the ESM-only v7 import).
//
// Consumed by:
//   - /app/frontend/src/pages/field/TodayBeat.jsx  (NextUp card)
//   - /app/frontend/src/pages/field/SalesReturnPanel.jsx (payload + validation)

// ---------- Item 3 · beats/today response parsing ----------
export function pickNextUp(data) {
  if (!data) return null;
  const sr = data.smart_route || {};
  if (sr.applied === false) return null;
  const pendingIds = sr.pending_sorted_by_distance || [];
  if (!pendingIds.length) return null;
  const nextId = pendingIds[0];
  const row = (data.outlets || []).find((r) => r?.outlet?.id === nextId);
  if (!row) return null;
  return {
    outlet: row.outlet,
    distance_m: row.distance_m_estimate,
    distance_kind: sr.distance_kind || null,
  };
}

export function formatDistance(distance_m, kind) {
  if (distance_m == null) return "Distance unavailable";
  const km = distance_m / 1000;
  const label = km >= 1
    ? `~${km.toFixed(1)} km`
    : `~${Math.round(distance_m)} m`;
  return kind === "haversine_straight_line"
    ? `${label} (straight line)`
    : label;
}

// ---------- Item 2 · Sales Return line validation + payload ----------
export function validateLine(line) {
  if (!line.sku_id) return "Pick a SKU";
  const n = Number(line.qty_kg);
  if (!Number.isFinite(n) || n <= 0) return "Qty must be > 0";
  if (!line.reason_code) return "Pick a reason";
  return null;
}

export function buildSaleReturnPayload({
  retailer_id, distributor_id, visit_id, gps, lines,
  idempotency_key, offline_captured = false,
}) {
  return {
    retailer_id,
    distributor_id: distributor_id || undefined,
    visit_id: visit_id || undefined,
    gps,
    lines: lines.map((l) => ({
      sku_id: l.sku_id,
      qty_kg: Number(l.qty_kg),
      reason_code: l.reason_code,
      photo_ref: l.photo_ref || undefined,
      note: (l.note || "").trim() || undefined,
    })),
    idempotency_key,
    offline_captured,
    client_ts: new Date().toISOString(),
  };
}
